// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings__actions--save[data-v-d07b4fc6]{margin-top:30px;height:44px}.small-sub[data-v-d07b4fc6]{margin-top:16px;font-size:14px!important;font-weight:400!important;color:#7c8b91!important}", ""]);
// Exports
module.exports = exports;
